import { render, staticRenderFns } from "./stock_inventory_chart.vue?vue&type=template&id=018e5149&scoped=true"
import script from "./stock_inventory_chart.vue?vue&type=script&lang=js"
export * from "./stock_inventory_chart.vue?vue&type=script&lang=js"
import style0 from "./stock_inventory_chart.vue?vue&type=style&index=0&id=018e5149&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e5149",
  null
  
)

export default component.exports